import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";

import { db } from "../firebase/config";
const itemCollectionRef = collection(db, "item");

const getAllItem = async () => {
  const itemSnapshot = await getDocs(itemCollectionRef);
  const itemList = itemSnapshot.docs.map((doc) => {
    return {
      ...doc.data(),
      id: doc.id,
    };
  });
  return itemList;
};

const createItem = async (item) => {
  const docRef = await addDoc(itemCollectionRef, item);
  return {
    id: docRef.id,
    ...item,
  };
};

const updateItem = async (item) => {
  const docRef = doc(db, "item", item.id);
  await updateDoc(docRef, item);
  return item;
};

const deleteItem = async (id) => {
  const docRef = doc(db, "item", id);
  await deleteDoc(docRef);
};

const getItemById = async (id) => {
  const docRef = doc(db, "item", id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return {
      id: docSnap.id,
      ...docSnap.data(),
    };
  } else {
    return null;
  }
};

const getItemByItemNumber = async (itemNumber) => {
  const itemSnapshot = await getDocs(itemCollectionRef);
  const itemList = itemSnapshot.docs.map((doc) => {
    return {
      ...doc.data(),
      id: doc.id,
    };
  });
  // @ts-ignore
  const item = itemList.find((item) => item.item === itemNumber.toString());

  if (item) {
    return item;
  } else {
    return null;
  }
};

export {
  getAllItem,
  createItem,
  updateItem,
  deleteItem,
  getItemById,
  getItemByItemNumber,
};
